<template>
  <v-container>
    <h1 class="text-headline-small font-weight-bold mb-2">Dangers signalés sur les rivières du Québec</h1>
    <p class="text-body-medium text-medium-emphasis mb-6">
      Arbres, éboulis, rapides modifiés : les dangers actifs signalés par la communauté. Ces informations peuvent ne
      plus être à jour : vérifiez toujours sur place et repérez les rapides en cas de doute.
    </p>

    <v-skeleton-loader v-if="loading" type="card@2"></v-skeleton-loader>
    <v-empty-state
      v-else-if="!groups.length"
      icon="mdi-shield-check-outline"
      size="64"
      title="Aucun danger actif signalé"
      text="Si vous voyez un danger sur une rivière, signalez-le dans l'onglet Dangers de la section."
    ></v-empty-state>
    <section v-for="group in groups" v-else :key="group.sectionId" class="mb-8">
      <div class="d-flex flex-wrap align-center ga-2 mb-3">
        <h2 class="text-title-large font-weight-medium flex-grow-1">{{ group.river }} - {{ group.name }}</h2>
        <v-btn
          variant="tonal"
          color="primary"
          append-icon="mdi-arrow-right"
          :to="{ name: 'riviere', params: { slug: group.alias }, query: { onglet: 'dangers' } }"
        >
          Voir la section
        </v-btn>
      </div>
      <v-row>
        <v-col v-for="danger in group.dangers" :key="danger.id" cols="12" lg="6">
          <danger-card :danger="danger"></danger-card>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script>
  import DangerCard from "@/components/pages/river/components/DangerCard.vue";
  import { DangersService } from "@/store/modules/dangers";
  import { groupDangersBySection } from "@/utils/dangers";
  import { applySeoMeta, buildRouteSeo, signalPrerenderReady } from "@/utils/seo";

  // Public list of every active danger, grouped by section. Check-ups and reports happen on the section page.
  export default {
    name: "ActiveDangers",
    components: { DangerCard },
    data() {
      return { loading: true, groups: [] };
    },
    async mounted() {
      try {
        this.groups = groupDangersBySection(await DangersService.actions.getActiveDangers());
      } catch (error) {
        console.error("Error fetching active dangers:", error);
      } finally {
        this.loading = false;
        this.applySeo();
        this.$nextTick(() => signalPrerenderReady());
      }
    },
    methods: {
      applySeo() {
        const count = this.groups.reduce((total, group) => total + group.dangers.length, 0);
        const rivers = [...new Set(this.groups.map((group) => group.river))].join(", ");
        const routeSeo = buildRouteSeo(this.$route);
        const plural = count > 1 ? "s" : "";
        const dangersText = `${count} danger${plural} actif${plural} signalé${plural} : ${rivers}.`;
        applySeoMeta({
          ...routeSeo,
          description: count ? `${dangersText} ${routeSeo.description}`.slice(0, 300) : routeSeo.description,
        });
      },
    },
  };
</script>
